import { AfterViewInit, Component, ComponentRef, effect, input, InputSignal, OnInit, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { ATOMIC_MAPPING } from '../../atomic-blueprint/mapping';
import { AtomicBlueprint } from 'src/openapi-client';

export interface AtomicBlueprintSupported<T> {
  data: InputSignal<T>
}

type AtomicComponentType = InstanceType<(typeof ATOMIC_MAPPING)[keyof typeof ATOMIC_MAPPING]>;

@Component({ 
  selector: 'app-atomic',
  imports: [],
  templateUrl: './atomic.component.html',
  styleUrl: './atomic.component.scss'
}) 
export class AtomicComponent {
  readonly blueprint = input.required<AtomicBlueprint>();

  @ViewChild('container', { read: ViewContainerRef, static: true }) 
  private readonly container!: ViewContainerRef;

  constructor() { 
    effect(() => {
      this.spawn(this.blueprint());  
    })
  }
  
  private spawn<T extends { type: keyof typeof ATOMIC_MAPPING }>(data: T) : ComponentRef<AtomicComponentType> {
    this.container.clear(); 
    const componentType = ATOMIC_MAPPING[data.type] as Type<any>;
    const component = this.container.createComponent(componentType);
    component.setInput('data', data); 
    return component; 
  }
} 
 